/**
 * スマートフォン用引き出しメニュー
 */
import PerfectScrollbar from 'perfect-scrollbar';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
export const drawerMenu = (selector, option) => {
    const rootEl = document.querySelector(selector);
    if (rootEl) {
        return new DrawerMenu(rootEl, option);
    }
    return null;
};
class DrawerMenu {
    rootEl;
    mainEl;
    scrollBar;
    isShow = false;
    duration = 300;
    timerID;
    enterClass = 'enter';
    leaveClass = 'leave';
    option;
    constructor(el, option) {
        this.rootEl = el;
        const mainEl = el.querySelector('.drawer-menu-main');
        if (mainEl) {
            this.mainEl = mainEl;
        }
        if (option) {
            this.option = option;
        }
        // スクロール機能の初期化
        this.initScrollFunction();
        // オーバレイで閉じる機能の初期化
        this.initOverlayClose();
        // リンククリックの初期化
        this.initClickLinkHandler();
    }
    // スクロール機能の初期化
    initScrollFunction() {
        if (!this.mainEl) {
            return;
        }
        // スクロール機能の初期化
        this.scrollBar = new PerfectScrollbar(this.mainEl);
    }
    // オーバーレイで閉じる
    initOverlayClose() {
        const overlayEl = this.rootEl?.querySelector('.drawer-menu-overlay');
        if (!overlayEl) {
            return;
        }
        overlayEl.addEventListener('click', () => this.toggle(false));
    }
    // リンククリックの初期化
    initClickLinkHandler() {
        if (!this.mainEl) {
            return;
        }
        // リンク要素の取得
        const linkEls = this.mainEl.querySelectorAll('.drawer-menu-link');
        if (linkEls.length === 0) {
            return;
        }
        Array.from(linkEls).forEach((linkEl) => {
            // クリックイベントのハンドリング
            linkEl.addEventListener('click', (evt) => {
                if (this.option && this.option.on && this.option.on.clickLink) {
                    this.option.on.clickLink(evt.target);
                }
            });
        });
    }
    // 開閉トグル
    toggle(isShow) {
        if (!this.rootEl) {
            return;
        }
        clearTimeout(this.timerID);
        if (isShow !== undefined) {
            this.isShow = isShow;
        }
        else {
            this.isShow = !this.isShow;
        }
        if (this.mainEl) {
            if (this.isShow) {
                const scrollPosition = window.pageYOffset;
                const bodyEl = document.querySelector('body');
                disableBodyScroll(this.mainEl);
                if (bodyEl) {
                    bodyEl.style.top = `-${scrollPosition}px`;
                }
            }
            else {
                enableBodyScroll(this.mainEl);
            }
        }
        const removeClassName = this.isShow ? this.leaveClass : this.enterClass;
        const addClassName = this.isShow ? this.enterClass : this.leaveClass;
        this.rootEl.classList.remove(removeClassName);
        this.rootEl.classList.remove(`${removeClassName}-active`);
        this.rootEl.classList.remove(`${removeClassName}-done`);
        this.rootEl.classList.add(addClassName);
        if (this.isShow && this.option?.on) {
            if (this.option.on.beforeOpen) {
                this.option.on.beforeOpen();
            }
        }
        else {
            if (this.option?.on.beforeClose) {
                this.option.on.beforeClose();
            }
        }
        window.setTimeout(() => {
            if (this.rootEl) {
                this.rootEl.classList.add(`${addClassName}-active`);
            }
        }, 1);
        this.timerID = window.setTimeout(() => {
            if (this.rootEl) {
                this.rootEl.classList.remove(`${addClassName}-active`);
                this.rootEl.classList.add(`${addClassName}-done`);
            }
        }, this.duration);
    }
}
